// extracted by mini-css-extract-plugin
export default {"container":"proof-ready_container__Zow0a","greenButton":"proof-ready_greenButton__IBp-G"};